import { render, staticRenderFns } from "./GBRightPaneColorSelect.vue?vue&type=template&id=990c7f16&"
import script from "./GBRightPaneColorSelect.vue?vue&type=script&lang=js&"
export * from "./GBRightPaneColorSelect.vue?vue&type=script&lang=js&"
import style0 from "./GBRightPaneColorSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VTextField})
